/**
 * @desc 查询-sku库存变动记录
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.changeRecordPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/changeRecordPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
